import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { getBlogPost } from "@/lib/api";
import { pickL } from "@/lib/content";
import { useLang } from "@/context/LanguageContext";
import Breadcrumb from "@/components/Breadcrumb";
import NewsletterSection from "@/components/NewsletterSection";

export default function BlogPost() {
  const { slug } = useParams();
  const { t, lang } = useLang();
  const [post, setPost] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    setPost(null);
    setError(false);
    getBlogPost(slug).then(setPost).catch(() => setError(true));
  }, [slug]);

  if (error) {
    return (
      <div className="empty-state" data-testid="blogpost-not-found">
        <h2>{t("blog.notFound")}</h2>
        <Link to="/blog" className="btn-primary">{t("nav.rituals")}</Link>
      </div>
    );
  }

  if (!post) {
    return <div className="loader" data-testid="blogpost-loading"><div className="spinner" /></div>;
  }

  const title = pickL(post, "title", lang);
  const content = pickL(post, "content", lang) || [];

  return (
    <>
      <Breadcrumb
        trail={[
          { label: t("nav.home"), to: "/" },
          { label: t("nav.rituals"), to: "/blog" },
          { label: title },
        ]}
      />

      <article className="blog-post" data-testid="blog-post">
        <img className="cover" src={post.image} alt={title} />
        <p className="meta">{pickL(post, "category", lang)} · {post.date}</p>
        <h1>{title}</h1>
        {content.map((para, i) => (
          <p key={i}>{para}</p>
        ))}
        <Link to="/blog" className="btn-ghost" style={{ marginTop: "1.5rem" }} data-testid="blogpost-back">
          ← {t("blog.title")}
        </Link>
      </article>

      <NewsletterSection />
    </>
  );
}
